import { type StateCreator } from 'zustand';

import { type UseTrackCanvasViewedParams } from '@air/analytics';

export type CanvasViewedFrom = UseTrackCanvasViewedParams['viewed_from'];

export type WorkspaceRightPanelCanvasSlice = {
  initialSelectedNodeId: string | null;
  selectedCanvasId: string | null;
  canvasViewedFrom: CanvasViewedFrom;
  setSelectedCanvasId: (canvasId: string | null, viewedFrom?: CanvasViewedFrom) => void;
  setInitialSelectedNodeId: (nodeId: string | null) => void;
};

export type CreateWorkspaceRightPanelCanvasSlice = () => StateCreator<
  WorkspaceRightPanelCanvasSlice,
  [],
  [],
  WorkspaceRightPanelCanvasSlice
>;

export const createWorkspaceRightPanelCanvasSlice: CreateWorkspaceRightPanelCanvasSlice = () => (set) => ({
  initialSelectedNodeId: null,
  selectedCanvasId: null,
  canvasViewedFrom: undefined,
  setSelectedCanvasId: (canvasId: string | null, viewedFrom?: CanvasViewedFrom) => {
    set({ selectedCanvasId: canvasId, canvasViewedFrom: canvasId ? viewedFrom : undefined });
  },
  setInitialSelectedNodeId: (nodeId: string | null) => {
    set({ initialSelectedNodeId: nodeId });
  },
});
